export const gameConstants = {
  SET_DATA: 'SET_GAME_DATA',
  ADD_PLAYERS: 'ADD_PLAYERS',
  SET_ROUND: 'SET_ROUND',
  SET_LISTS: 'SET_LISTS',
};
